<template>
  <el-config-provider :locale="elLocale">
    <router-view />
  </el-config-provider>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import en from 'element-plus/lib/locale/lang/en'
import ja from 'element-plus/lib/locale/lang/ja'
import ko from 'element-plus/lib/locale/lang/ko'
import zhTW from 'element-plus/lib/locale/lang/zh-tw'

export default {
  setup() {
    const { locale } = useI18n()
    const elLocale = computed(() => {
      const localeMap = { 'zh': zhCn, 'en': en, 'ja': ja, 'ko': ko, 'zh-TW': zhTW }
      return localeMap[locale.value] || en
    })
    return { elLocale }
  },
}
</script>
